export default {
  title: {
    id: 'presentation_title_first_line',
    defaultMessage: 'Welcome to Back Market,',
  },
  subtitle: {
    id: 'presentation_title_next_line',
    defaultMessage: 'the refurbished (super) market.',
  },
  moreReviews: {
    id: 'presentation_more_reviews',
    defaultMessage: 'See the reviews of {votes} backers',
  },
  backLabel: {
    id: 'presentation_back_label_button',
    defaultMessage: 'Our quality label',
  },

  block1Title: {
    id: 'presentation_block1',
    defaultMessage: 'Best offer available',
  },
  block1Text: {
    id: 'presentation_block1_text',
    defaultMessage: 'Selected by our price-quality algorithm.',
  },
  block2Title: {
    id: 'presentation_block2',
    defaultMessage: 'Guaranteed quality',
  },
  block2Text: {
    id: 'presentation_block2_text',
    defaultMessage: 'Our partner merchants are continuously monitored.',
  },
  block3Title: {
    id: 'presentation_block3',
    defaultMessage: 'Amazing service',
  },
  block3Text: {
    id: 'presentation_block3_text',
    defaultMessage: 'Secure shopping experience.',
  },
  block4Title: {
    id: 'presentation_block4',
    defaultMessage: 'Positive impact',
  },
  block4Text: {
    id: 'presentation_block4_text',
    defaultMessage: 'An alternative to new, joyful and elegant.',
  },

  learnMore: {
    id: 'presentation_button',
    defaultMessage: 'learn more about Back Market',
  },
}
